module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }